module.exports = __webpack_public_path__ + "static/media/product-team-second.e05a8d1f.svg";